module.exports = __webpack_public_path__ + "img/marker-icon-2x.401d815.png";